import { render, staticRenderFns } from "./PositionsShowOpenTrades.vue?vue&type=template&id=059f5ad9&scoped=true"
import script from "./PositionsShowOpenTrades.vue?vue&type=script&lang=js"
export * from "./PositionsShowOpenTrades.vue?vue&type=script&lang=js"
import style0 from "./PositionsShowOpenTrades.vue?vue&type=style&index=0&id=059f5ad9&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "059f5ad9",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSkeletonLoader } from 'vuetify/lib/components/VSkeletonLoader';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VToolbar } from 'vuetify/lib/components/VToolbar';
import { VToolbarTitle } from 'vuetify/lib/components/VToolbar';
installComponents(component, {VCol,VDataTable,VIcon,VRow,VSkeletonLoader,VSpacer,VToolbar,VToolbarTitle})
